import React, { useEffect, useReducer, useState } from 'react'
import { Button, Col, Container, Row, Spinner, Stack, Tab, Tabs } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import { IoIosArrowRoundDown } from "react-icons/io";
import axiosInstance from '../utils/axiosConfig';
import toast from 'react-hot-toast';
import moment from 'moment';
import _, { filter } from 'lodash'
import ReactDatePicker from 'react-datepicker';
import Select from 'react-select'
import { NotFound } from '../Components/NotFound';
import RadioComponent from '../Components/RadioComponent';

function reducer(state, action){
    switch(action.type){
        case 'loading': {
            return {
                ...state,
                loader: action.loader
            }
        }
        case 'data': {
            return {
                ...state,
                data: action.data
            }
        }
        case 'filter': {
            return {
                ...state,
                filter: action.filter
            }
        }
        default:
            return state
    }
}

const options = [
    { value: 'registration', label: 'Registration' },
    { value: 'finance', label: 'Finance' },
    { value: 'directIBDIC', label: 'Direct IBDIC'},
    { value: 'cancellation', label: 'cancellation' },
    { value: 'disbursement', label: 'Disbursement' },
    { value: 'UsageMISforIDP', label: 'IDP wise billing MIS' },
    { value: 'IdpWiseDailyTrend', label: 'IdpWise Daily Trend' },
    { value: 'IdpWise', label: 'IdpWise' },
    { value: 'repayment', label: 'Repayment' },
    { value: 'statusCheck', label: 'Status Check' },
    { value: 'misHub', label: 'MisHub' },
    { value: 'totalBusiness', label: 'Total Business' },
    { value: 'summary', label: 'Summary' },
    { value: 'consentData', label: 'Consent Data' },
    { value: 'gspApiCalls', label: 'GSP Api Calls' }


]

export const Mis = () => {
    const [state, dispatch] = useReducer(reducer, {
        data: {},
        loader: false,
        filter: {
            filterType: 'all',
            fromDate: moment().subtract(1, 'M').format('DD/MM/YYYY'),
            toDate: moment().format('DD/MM/YYYY'),
            idpId: {},
            reportType: options[0]
        }
    })

    const sortIcon = <IoIosArrowRoundDown className='text-dark' />
    const paginationComponentOptions = {
        noRowsPerPage: true,
    }
    const [key, setKey] = useState('0');
    const [idpidOptions, setIdpidOptions] = useState([])

    useEffect(() => {
        console.log("hbjbbhjbjs",Object.keys(state.filter.idpId));
       if(Object.keys(state.filter.idpId).length > 0){
        fetchData({
            ...state.filter,
            idpId: state.filter.idpId.map(item => item.value),
            reportType: state.filter.reportType.value
        })
       }
    }, []);

    const fetchData = (filter) => {
        dispatch({
            type:'loading',
            loader: true
        })
        axiosInstance().post(
            'portal-api/get-invoice-hub-mis-report',
            filter
       ).then((res) => {
        if([200].includes(res.data?.code)) {
            dispatch({
                type: 'loading',
                loader: false
            })
            dispatch({
                type: 'data',
                data: res.data.data
            })
        } else {
            toast.error(res.data?.message)
            dispatch({
                type:'loading',
                loader: false
            })
        }
       }).catch(err => {
            toast.error(err.toString())
            console.log(err)
            dispatch({
                type:'loading',
                loader: false
            })
       })
       toast.dismiss()
    }

    const download = () => {
        console.log(state);
        console.log("vvjbjhbjbvhvhfhvjbjbjbvjvjvj",state.filter.idpId);
        toast.promise(
            axiosInstance().post(
                'portal-api/download-invoice-hub-mis-report',
                {
                    ...state.filter,
                    idpId: Array.isArray(state.filter.idpId) ? state.filter.idpId.map(item => item.value): [state.filter.idpId].map(item => item.value),
                    reportType: state.filter.reportType.value,
                },
                {
                    responseType: 'blob', // important
                }
            ),
            {
                loading: 'Downloading...',
                success: (res) => {
                    console.log(res);
                    console.log(res.config.headers);
                    // console.log(res.headers.get('X-Filename'));

                    // Extract filename from content-disposition header
                    const contentDisposition = res.headers['content-disposition'];
                    let downloadFilename = 'sample';
                    if (contentDisposition) {
                        const filenameMatch = contentDisposition.match(/filename="?(.+?)"?$/);
                        if (filenameMatch.length === 2) {
                        downloadFilename = filenameMatch[1];
                        }
                    }
                    console.log("Download file name "+downloadFilename);
                    // console.log(res.data.type)
                    const href = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = href;
                    link.setAttribute('download', downloadFilename); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    return 'Successfully Download'
                },
                error: (err) => <b>{err.toString()}</b>,
            }
        );
        toast.dismiss()
    }

    useEffect(() => {
        axiosInstance().post(
            'consent-api/getIdpList',
            {
                // gspUserId: "3"
            }
       ).then((res) => {
        if([200].includes(res.data?.code)) {
            let listOptions = _.filter(res.data.idpData.map((item) => ({
                value: item.idpCode.toString(),
                label: item.idpName
            })), function(o){
                return o.value !== '';
            })
            setIdpidOptions(listOptions)
            if(res.data.idpData.length > 0){
                dispatch({ type: 'filter', filter: {
                    ...state.filter,
                    idpId: listOptions[0]
                }})
                fetchData({
                    ...state.filter,
                    idpId: [listOptions[0].value],
                    reportType: state.filter.reportType.value
                })
            }
        } else {
            toast.error(res.data?.message)
        }
       }).catch(err => {
            toast.error(err.toString())
            console.log(err)
       })
    }, [])

    return (
        <div className="home-container">
            <Container fluid className='h-100' style={{ margin: '10px 0', zIndex: '1' }}>
                <Stack gap={3}>
                    <Row className='shadow-sm bg-white sticky-top py-3 mb-2' style={{ zIndex: '1' }}>

                        <Col xs={10}>
                            <Stack direction="horizontal" gap={3}>
                            <RadioComponent state={state} dispatch={dispatch}/>
                            {
                                state.filter.filterType === 'date' ?  
                                <>
                                <ReactDatePicker
                                    showIcon
                                    value={state.filter.fromDate}
                                    selected={new Date(moment(state.filter.fromDate, 'DD/MM/YYYY'))}
                                    onChange={(date) => {
                                        dispatch({type: 'filter', filter: {
                                            ...state.filter,
                                            ...{fromDate: moment(date).format('DD/MM/YYYY')}
                                        }})
                                    }}
                                    placeholderText="From Date"
                                    dateFormat="DD/MM/yy"
                                    name="fromDate"
                                    wrapperClassName={{width: '158px'}}
                                    maxDate={new Date()}
                                    icon={<svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect><line x1="16" x2="16" y1="2" y2="6"></line><line x1="8" x2="8" y1="2" y2="6"></line><line x1="3" x2="21" y1="10" y2="10"></line><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>}
                                />
                                <ReactDatePicker
                                    showIcon
                                    maxDate={new Date()}
                                    minDate={new Date(moment(state.filter.fromDate, 'DD/MM/YYYY'))}
                                    selected={new Date(moment(state.filter.toDate, 'DD/MM/YYYY'))}
                                    value={state.filter.toDate}
                                    style={{width: '158px'}}
                                    placeholderText="To Date"
                                    onChange={(date) => {
                                        dispatch({type: 'filter', filter: {
                                            ...state.filter,
                                            ...{toDate: moment(date).format('DD/MM/YYYY')}
                                        }})
                                    }}
                                    dateFormat="DD/MM/yy"
                                    name="toDate"
                                    icon={<svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><rect width="18" height="18" x="3" y="4" rx="2" ry="2"></rect><line x1="16" x2="16" y1="2" y2="6"></line><line x1="8" x2="8" y1="2" y2="6"></line><line x1="3" x2="21" y1="10" y2="10"></line><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg>}
                            
                                /></>:null
}
                                <Select
                                    defaultValue={state.filter.reportType}
                                    options={options}
                                    name='reportType'
                                    placeholder='Report Type'
                                    onChange={(value) => {
                                        dispatch({ type: 'filter', filter: {
                                            ...state.filter,
                                            reportType: value
                                        }})
                                    }}
                                />
                                {
                                state.filter.filterType === 'date' ?
                                <Select
                                    defaultValue={state.filter.idpId}
                                    options={idpidOptions}
                                    name='idpId'
                                    placeholder='IDP ID'
                                    onChange={(value) => {
                                        console.log(value);
                                        dispatch({ type: 'filter', filter: {
                                        ...state.filter,
                                        idpId: value
                                    }})}}
                                    isMulti={true}
                                    value={state.filter.idpId}
                                />:null
                            }
                                
                                {/* <Form.Select>
                                    {
                                        idpidOptions.map((item) => <option value={item.value}>{item.title}</option>)
                                    }
                                </Form.Select> */}
                                <Button variant="primary" onClick={() => {
                                    console.log(state.filter.idpId);
                                    fetchData({
                                    ...state.filter,
                                    idpId:  Array.isArray(state.filter.idpId) ? state.filter.idpId.map(item => item.value): [state.filter.idpId].map(item => item.value),
                                    reportType: state.filter.reportType.value
                                })}}>Apply</Button>
                            </Stack>
                        </Col>
                        <Col xs={2} className='d-flex justify-content-end'>
                            <Button variant="primary" onClick={() => download()}>Download</Button>
                        </Col>

                    </Row>
                    <div style={{ zIndex: 0 }}>
                        {
                            state.loader ? <div className='d-flex justify-content-center align-items-center mt-20' style={{height: '100%'}}>
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div> :
                            <Tabs
                                id="controlled-tab-example"
                                activeKey={key}
                                onSelect={(k) => setKey(k)}
                                className="mb-1"
                            >
                                {
                                    Object.keys(state.data).map((item, index) => {

                                        const consentTablecolumns = []
                                        for (let col of Object.keys(state.data[item].length > 0 ? state.data[item][0] : {})){
                                            consentTablecolumns.push({
                                                name: col,
                                                selector: row => row[col],
                                                sortable: true,
                                            })
                                        }

                                        return (
                                            <Tab eventKey={index} title={item==='UsageMISforIDP' ? 'Usage MIS For IDP'.toLowerCase(): item.toLowerCase() } key={index}>
                                                {
                                                    state.data[item].length <= 0 ?
                                                        <NotFound /> :
                                                        <DataTable
                                                            columns={consentTablecolumns}
                                                            data={state.data[item]}
                                                            sortIcon={sortIcon}
                                                            highlightOnHover
                                                            pagination
                                                            paginationComponentOptions={paginationComponentOptions}
                                                        />
                                                }
                                            </Tab>
                                        )
                                    })
                                }
                            </Tabs>
                        }
                    </div>
                </Stack>
            </Container>
        </div>
    )
}
